import React, { useState } from "react";
import BackLogout from "../component/backLogout";
import Loader from "../component/loader";
import { useToast } from "@chakra-ui/react";
// import { useNavigate } from "react-router-dom";

function Payment() {
    const toast = useToast();
    const [paymentObj, setPaymentObj] = useState({});
    const [payloader, setPayloader] = useState(false);

    // const navigate = useNavigate();

  const handlePaymentAPI = () => {

    // paymentObj['Branch_id'] = "1729";
    paymentObj['Branch_id'] = "2244";
    paymentObj['student_id'] = localStorage.getItem('studentId');
    // paymentObj['amount'] = '1';
    paymentObj['amount'] = '3200';
    paymentObj['db_name'] = 'erp_eshiksa';
    paymentObj['email'] = localStorage.getItem('email');
    
    

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ci_session=uouulpjib3t1tdgu2bn6pcsqt4k51bvr");
    myHeaders.append("auth_token", localStorage.getItem('token'));
    var raw = JSON.stringify(paymentObj);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow", 
    };

    fetch(
      "https://erpapi.eshiksa.net/Gadvasu/payFees.php",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {console.log(result)
        var responseObject = JSON.parse(result);
        if(responseObject.success === 1){
          setPayloader(false);
            window.location.replace(responseObject.url);
        }else{
          toast({
            title: 'Alert',
            description: responseObject.msg,
            status: 'error',
            duration: 1000,
            isClosable: true,
            position: 'top',
          })
        }

        setPayloader(false);
    })
      .catch((error) => console.log("error", error));
  };

  const submitPayment = (e) => {
    e.preventDefault();

    setPayloader(true);
    handlePaymentAPI();

  }

  return (
    <React.Fragment>
      <div className="container" style={{ height: "100vh" }}>

      <div>
        <BackLogout/>
      </div>

        <form onSubmit={(e) => submitPayment(e)}>
          <div className="row border border-3 rounded-3 my-3">
            <div className="p-0">
              <div className="w-100 p-1 pt-2 px-3 form_input_header">
                <h6 className="text-light"> Payment Details</h6>
              </div>
            </div>
            <div className="row p-3">
                <div className="col-sm-12 col-lg-4">
                        {/* <h3>Form Fees = 1 Rs</h3> */}
                        <h3>Form Fees = 3200 Rs</h3>
                </div>
            </div>
            <div className="row p-3">
                <div className="col-sm-12 col-lg-4">  
                <label className="form-label"> Choose Payment Mode </label>
              <select className="form-select" name="pay_mode" onChange={(e) => setPaymentObj({...Payment, [e.target.name] : e.target.value})} >
                <option value="" selected disabled>
                  {" "}
                  Select{" "}
                </option>
                <option value="NB">Net Banking</option>
                <option value="DC">Debit Card</option>
                <option value="CC">Credit Card</option>
                <option value="UPI">U.P.I</option>
              </select>
                </div>
            </div>
          </div>

          <div className="row justify-content-around my-5">
            <button
            type="submit"
            className="btn btn-primary w-25"
            disabled={payloader}
          >
            Proceed to pay
            {
              payloader && <Loader/>
            }
            
          </button>
            {/* <input type="button" className="btn btn-primary w-25" onClick={() => navigate("/FormPreview")} value={'Preview form'}/> */}
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}

export default Payment;
